// extracted by mini-css-extract-plugin
export default {"products":"Wishlist_products__+-l4s","no_data":"Wishlist_no_data__TZjZ+","products_list":"Wishlist_products_list__h7JKs"};